export interface Settings {
    mixpanel: {
        token: string;
    },
    azure: {
        applicationInsights: {
            instrumentationKey: string;
        }
    },
    api: {
        url: string;
    },
    сloudSite: {
        name: string,
        protocol: string
    },
    tos: {
        url: string;
    }
};

export const settings = <Settings>(<any>window).settings;